import React from "react";
import { SiteGeneralLayout } from "./components";

const App = () => {
  return <SiteGeneralLayout />;
};

export default App;
